import AppBase from './app/AppBase';
import { viewTypes } from './constants/view-types';

export default class extends AppBase {
  constructor() {
    super(...arguments);
    this.defaultRoute = '/admin';
    this.viewType = viewTypes.ADMIN;
  }
}
